Controller.$inject = ['$element', '$scope'];

function Controller($element, $scope) {
    let self = this;
    self.showLegend = false;
    self.inputFocused = false;
    self.isOpen = false;

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
    };

    const detachMenu = () => {
        if (self.menuElm) {
            self.menuElm.style.display = 'none';
        }
        document.removeEventListener('click', handler);
    };

    self.handleBlur = () => {
        self.inputFocused = false;
        if ((Array.isArray(self.ngModel) && !self.ngModel?.length) || (!Array.isArray(self.ngModel) && !self.ngModel)) {
            self.showLegend = false;
        }
    };

    self.getDisplayedItems = () => {
        const inputElement = $element[0].querySelector('input[type="text"]');
        if ((Array.isArray(self.ngModel) && self.ngModel?.length) || (!Array.isArray(self.ngModel) && self.ngModel)) {
            inputElement.classList.remove('placeholder');
            return Array.isArray(self.ngModel)
                ? self.ngModel.map((item) => item[self.textKey] || '').filter(Boolean).join(', ')
                : (self.ngModel[self.textKey] || self.ngModel);
        } else {
            if (self.labelVariant === 'outlined') {
                self.showLegend = false;
            }
            inputElement.classList.add('placeholder');
        }
    };

    self.toggleMenu = () => {
        const toggleElm = $element[0].querySelector('input[type="text"]');
        if (!self.menuElm) {
            let parent = $element[0].parentElement;
            while (parent) {
                const foundMenu = parent.querySelector('.hui-menu') ||
                                           parent.querySelector('.hui-popover');
                if (foundMenu) {
                    self.menuElm = foundMenu;
                    break;
                }
                parent = parent.parentElement;
            }
        }
        const menuNative = self.menuElm;
        if (menuNative && toggleElm) {
            if (self.isOpen) {
                detachMenu();
                self.isOpen = false;
                self.handleChange();
            } else {
                self.isOpen = true;
                menuNative.style.display = 'block';
                menuNative.style.position = 'absolute';
                menuNative.style.top = '0px';
                menuNative.style.left = '0px';
                const hostElm = self.appendTo
                    ? document.querySelector(self.appendTo)
                    : document.body;
                hostElm.appendChild(menuNative);

                try {
                    const options = {
                        placement: self.menuPlacement || 'bottom-start',
                        removeOnDestroy: true
                    };

                    self.popper = new Popper(toggleElm, menuNative, options);
                    document.addEventListener('click', handler);
                } catch (e) {
                    console.error('Popper failed to initialize', e);
                }
            }
        }
    };

    const handler = (event) => {
        if (self.isOpen && !$element[0]?.contains(event.target)) {
            self.toggleMenu();
            $scope.$applyAsync();
        }
    };

    self.$postLink = () => {
        document.addEventListener('click', handler);
        $element[0].closest('hui-dropdown-items')?.addEventListener('click', handler);
        const inputElement = $element[0].querySelector('input[type="text"]');
        if (!self.ngModel || (Array.isArray(self.ngModel) && !self.ngModel?.length)) {
            inputElement.classList.add('placeholder');
            self.showLegend = false;
        } else {
            if (self.labelVariant === 'outlined') {
                self.showLegend = true;
            }
            inputElement.classList.remove('placeholder');
            inputElement.value = self.getDisplayedItems();
        }
    };

    self.handleChange = ($event) => {
        const inputElement = $element[0].querySelector('input[type="text"]');
        inputElement.value = self.getDisplayedItems() ? self.getDisplayedItems() : '';
        self.onChange({$event});
    };

    $scope.$watch(() => self.ngModel, (newValue, oldValue) => {
        if (newValue !== oldValue) {
            self.handleChange();
        }
    }, true);

    self.$onDestroy = () => {
        detachMenu();
        self.popper?.destroy();
        self.popper = null;
    };
}

export function HuiInputSelect() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            labelVariant: '@',
            iconPosition: '@',
            ngModel: '=',
            placeholder: '@',
            hName: '@',
            disabled: '<',
            onChange: '&',
            textKey: '@',
            appendTo: '@',
            hasBadges: '<',
            isLoading: '<',
            fullWidth: '<',
            menuPlacement: '@',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon',
            badges: '?huiInputBadges',
        },
        template: () => {
            return `
                <hui-input-base
                    label-variant="{{$huiCtrl.labelVariant}}"
                    icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                    has-error="$huiCtrl.hasError"
                    show-legend="$huiCtrl.showLegend"
                    input-focused="$huiCtrl.inputFocused"
                    model-value="$huiCtrl.ngModel"
                    disabled="$huiCtrl.disabled"
                    full-width="$huiCtrl.fullWidth">
                    <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                    <hui-input-base-icon ng-transclude ng-transclude-slot="icon"></hui-input-base-icon>
                    <div ng-if="$huiCtrl.hasBadges" ng-transclude ng-transclude-slot="badges"></div>
                    <input type="hidden" 
                           ng-model="$huiCtrl.ngModel" />
                    <input type="text" 
                           ng-click="$huiCtrl.toggleMenu()"
                           class="hui-base-input hui-input-select"
                           readonly
                           attr.value="{{$huiCtrl.hasBadges ? '' : $huiCtrl.getDisplayedItems()}}"
                           ng-disabled="$huiCtrl.disabled"
                           name="{{$huiCtrl.hName}}"
                           placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                           ng-focus="$huiCtrl.handleFocus()"
                           ng-blur="$huiCtrl.handleBlur()"
                           ng-class="{'d-none': $huiCtrl.hasBadges}"
                           />
                    <i class="fa hui-select-arrow text-primary" 
                       ng-click="$huiCtrl.hasBadges && $huiCtrl.toggleMenu()"
                       ng-class="{'fa-chevron-down': !$huiCtrl.isOpen && !$huiCtrl.isLoading,
                                  'fa-chevron-up': $huiCtrl.isOpen && !$huiCtrl.isLoading,
                                  'icon-disabled': $huiCtrl.disabled,
                                  'has-badges': $huiCtrl.hasBadges}"
                       aria-hidden="true"></i>
                 
                    <span ng-if="$huiCtrl.isLoading" 
                          class="d-flex align-items-center text-primary hui-select-arrow">
                      <i class="fa fa-circle-notch fa-spin"></i>
                    </span>
                </hui-input-base>
            `;
        }
    };
}
